<template>
	<div class="toggle-btn-group">
		<div class="toggle-btn">
			<div class="switch__container">
			  <input 
			  	:id="id" 
			  	class="switch switch--shadow" 
			  	type="checkbox" 
			  	@change="change">
			  <label :for="id"></label>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: [
			'id', 
			'default'
		],
		data(){
			return {
				check: false
			}
		},
		mounted(){
			if(this.default){
				document.getElementById(this.id).checked = true;
				this.check = true;
			}
		},
		methods: {
			change(){
				this.check = !this.check;
				this.$emit('tchange', this.check);
			}
		}
	}
</script>

<style scoped>
	.switch__container {
		margin-top: 10px;
	}
	.toggle-btn-group {
		margin-left: 3%;
	}
	.toggle-btn {
		display: flex;
	}
	.btn-label {
		margin-left: 20px;
		line-height: 45px;
	}
	.btn {
		margin-top: 20px;
	}
	.row {
		margin-top: 20px;
	}
	.switch {
	  position: absolute;
	  margin-left: -9999px;
	  visibility: hidden;
	}
	.switch + label {
	  display: block;
	  position: relative;
	  cursor: pointer;
	  outline: none;
	  user-select: none;
	}
	.switch--shadow + label {
	  padding: 2px;
	  width: 40px;
	  height: 20px;
	  background-color: #dddddd;
	  border-radius: 40px;
	}
	.switch--shadow + label:before,
	.switch--shadow + label:after {
	  display: block;
	  position: absolute;
	  top: 1px;
	  left: 1px;
	  bottom: 1px;
	  content: "";
	}
	.switch--shadow + label:before {
	  right: 1px;
	  background-color: #f1f1f1;
	  border-radius: 40px;
	  transition: all 0.4s;
	}
	.switch--shadow + label:after {
	  width: 20px;
	  background-color: #fff;
	  border-radius: 100%;
	  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
	  transition: all 0.4s;
	}
	.switch--shadow:checked + label:before {
	  background-color: #2E64FE;
	}
	.switch--shadow:checked + label:after {
	  transform: translateX(20px);
	}
</style>